import { useLayoutAdminSelector } from '@shared/store/model/selectors';

export const useScrollPageToTop = () => {
    const adminLayout = useLayoutAdminSelector();

    const scrollToTop = () => {
        adminLayout?.scrollTo(0, 0);
    };

    return scrollToTop;
};
